export class Configuracion {
  public con_usr_codigo: string;
  public con_ordenCompras: boolean;
  public con_confirmacion: boolean;
  public con_notificacion: boolean;
  codError: any;
  root: any;
  msgError: any;
  success: any;


  constructor(

  ) { }
}

